export default __webpack_public_path__ + "static/media/uploader-roche-2.823ea071.png";